import React, { useState } from "react";
import { Switch } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useSteps } from "../useSteps";
import { DropStoreModeConfirmation } from "./DropStoreModeConfirmation";

const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 72,
  height: 34,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(32px)",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#17E0C2",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#FFFFFF",
    width: 32,
    height: 32,
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: "#282F44",
    borderRadius: 20 / 2,
  },
}));

export const DropStoreModeToggle = ({ disabled = false }) => {
  const { dropStoreMode, setDropStoreMode } = useSteps();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [pendingValue, setPendingValue] = useState(false);

  const handleChange = (event) => {
    if (disabled) return;
    // Store the intended value and show confirmation
    setPendingValue(event.target.checked);
    setShowConfirmation(true);
  };

  const handleConfirm = () => {
    // Apply the change after confirmation
    setDropStoreMode(pendingValue);
    setShowConfirmation(false);
  };

  const handleCancel = () => {
    // Cancel the change
    setShowConfirmation(false);
  };

  return (
    <>
      <div
        className={`flex items-center gap-2 ${disabled ? "opacity-50" : ""}`}
      >
        <span className="text-sm font-medium text-[#8086A0] whitespace-nowrap">
          Drop-store mode
        </span>
        <CustomSwitch
          checked={dropStoreMode}
          onChange={handleChange}
          disabled={disabled}
          inputProps={{ "aria-label": "Drop store mode toggle" }}
        />
      </div>

      <DropStoreModeConfirmation
        isOpen={showConfirmation}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        isTurningOn={pendingValue}
      />
    </>
  );
};
